window.YotpoSpotlightObserver = {
    sectionSelector: '.section-{{ section.id }}',
    pointsSelector: '.yotpo-spotlight-cta-points',
    triggerSelector: '.yotpo-custom-spotlight-trigger',
    earningsSelector: '.yotpo-earnings',
    pointsObserver: null,
    containerObserver: null,

    init() {
      // this.section = document.querySelector(this.sectionSelector);
      // if (!this.section) return;

      const existing = document.querySelector(this.pointsSelector);

      if (existing) {
        this.observePointsElement(existing);
      } else {
        this.waitForElement();
      }

      document.addEventListener("sellingPlanChange", (event) => {
        console.log("selling plan changed event fired", event.detail.price);
        this.updateEarningsMessage(event.detail.price);
      });
    },

    updateRewardPoints() {
      const pointsElement = document.querySelector(this.pointsSelector);
      const triggerElements = document.querySelectorAll(this.triggerSelector);
      const isPDP = document.querySelector('.template-product');

      if (!pointsElement || triggerElements.length === 0) return;

      const value = pointsElement.getAttribute('data-original-balance');

      if (value !== null) {
        for(let i = 0; i < triggerElements.length; i++) {
          triggerElements[i].textContent = `You have ${value} points. Click here to view rewards.`;
          this.attachTriggerEvent(triggerElements[i]);
        }
      }
      
      // Assume this already exists
      let points = parseInt(value);

      // Helper
      const format = (pts) => pts.toLocaleString();

      const earningsEl = document.querySelector('[data-cart-loyalty-earnings]');
      const cartEarnings = earningsEl ? parseInt(earningsEl.getAttribute('data-cart-loyalty-earnings'), 10) : 0;

      // Target element where message will be shown
      const cartMessageEls = document.querySelectorAll('.cart-mini-container .yotpo-custom-spotlight-trigger');

      let cartMessage = '';

      if (typeof points === 'number') {
        const earningsMessage = `Earn <span class="yotpo-earnings">${format(cartEarnings)}</span> pts with this purchase`
        if (points < 100) {
          const remaining = 100 - points;
          cartMessage = `🌟 You are ${format(remaining)} pts away from $10 off 🌟`;
        } else if (points >= 100 && points <= 149) {
          cartMessage = `🌟 You have ${format(points)} pts. <u>Get $10 off</u> 🌟`;
        } else if (points >= 150 && points <= 199) {
          cartMessage = `🌟 You have ${format(points)} pts. <u>Get $15 off</u> 🌟`;
        } else if (points >= 200 && points <= 249) {
          cartMessage = `🌟 You have ${format(points)} pts. <u>Get $20 off</u> 🌟`;
        } else { // 250+
          cartMessage = `🌟 You have ${format(points)} pts. <u>Get $25 off</u> 🌟`;
        }
        
      } 

      // Render
      if (cartMessageEls.length > 0) {
        for(let i = 0; i < cartMessageEls.length; i++) {
          cartMessageEls[i].innerHTML = cartMessage;
        }
      }

      if(isPDP) {

        // Get earnings value from DOM
        const pdpEarningsEl = document.querySelector('[data-loyalty-earnings]');
        const pdpEarnings = pdpEarningsEl ? parseInt(pdpEarningsEl.getAttribute('data-loyalty-earnings'), 10) : 0;

        // Target element where message will be shown
        const pdpMessageEls = document.querySelectorAll('.product-single__content .yotpo-custom-spotlight-trigger');

        // Logic
        let pdpMessage = '';

        if (typeof points === 'number') {
          const earningsMessage = `Earn <span class="yotpo-earnings">${format(pdpEarnings)}</span> pts with this purchase`
          if (points < 100) {
            const remaining = 100 - points;
            pdpMessage = `🌟 You are ${format(remaining)} pts away from $10 off · ${earningsMessage}`;
          } else if (points >= 100 && points <= 149) {
            pdpMessage = `🌟 You have ${format(points)} pts. <u>Get $10 off</u> 🌟 ${earningsMessage}`;
          } else if (points >= 150 && points <= 199) {
            pdpMessage = `🌟 You have ${format(points)} pts. <u>Get $15 off</u> 🌟 ${earningsMessage}`;
          } else if (points >= 200 && points <= 249) {
            pdpMessage = `🌟 You have ${format(points)} pts. <u>Get $20 off</u> 🌟 ${earningsMessage}`;
          } else { // 250+
            pdpMessage = `🌟 You have ${format(points)} pts. <u>Get $25 off</u> 🌟 ${earningsMessage}`;
          }
          
        } 

        // Render
        if (pdpMessageEls.length > 0) {
          for(let i = 0; i < pdpMessageEls.length; i++) {
            pdpMessageEls[i].innerHTML = pdpMessage;
          }
        }
      }
    },

    updateEarningsMessage(price) {
      const earningsContainer = document.querySelector(this.earningsSelector);

      const points = parseInt(price.replace('$', ''));
      if(earningsContainer) {
        earningsContainer.innerText = points;
      }
    },

    attachTriggerEvent(element) {
      element.addEventListener('click', function() {
        document.dispatchEvent(new CustomEvent('yotpo-loyalty-spotlight-open-drawer'));
      });
    },

    observePointsElement(pointsElement) {
      if (!pointsElement) return;

      if (this.pointsObserver) {
        this.pointsObserver.disconnect();
      }

      this.pointsObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'data-original-balance'
          ) {
            this.updateRewardPoints();
          }
        });
      });

      this.pointsObserver.observe(pointsElement, {
        attributes: true,
        attributeFilter: ['data-original-balance']
      });

      this.updateRewardPoints();
    },

    waitForElement() {
      this.containerObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType !== 1) continue;

            if (node.matches && node.matches(this.pointsSelector)) {
              this.observePointsElement(node);
              this.containerObserver.disconnect();
              return;
            }

            const found = node.querySelector && node.querySelector(this.pointsSelector);
            if (found) {
              this.observePointsElement(found);
              this.containerObserver.disconnect();
              return;
            }
          }
        }
      });

      this.containerObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  };

  // Initialize
  window.YotpoSpotlightObserver.init();